<mat-checkbox [formControl]="control">
  {{ label | translate }}
</mat-checkbox>
